import * as React from 'react';
import { kodplaner_ekkodplaner } from '../../../../../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import { KodplanConsumer } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import EkonomiskAnalysInvalidYearDialog from './EkonomiskAnalysInvalidYearDialog';
import { kodplanIsActiveForYear } from '../../../../../../../Model/ModelContext/KodplanUtils';

interface IInvalidYearValidatorBag {
  validateYear: (year: number, commitCallback: () => void) => void;
}

interface IProps {
  children: (
    invalidYearValidatorBag: IInvalidYearValidatorBag
  ) => React.ReactNode;
}

interface IState {
  dialogOpen: boolean;
  commitCallback?: () => void;
  cancelCallback?: () => void;
  year?: number;
}

/**
 * En validator som visar en dialog med information när ett felaktigt år angets för den nuvarande kodplanen
 */
class EkonomiskAnalysYearValidator extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { dialogOpen: false };
  }

  validateYear =
    (activeKodplan: kodplaner_ekkodplaner | undefined) =>
    (year: number, commitCallback: () => void, cancelCallback?: () => void) => {
      const valid =
        activeKodplan == null
          ? true
          : kodplanIsActiveForYear(activeKodplan, year);

      if (valid) {
        commitCallback();
      } else {
        this.setState({
          dialogOpen: true,
          commitCallback: commitCallback,
          cancelCallback: cancelCallback,
          year,
        });
      }
    };

  onDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  onDialogExited = () => {
    this.setState({
      commitCallback: undefined,
      cancelCallback: undefined,
      year: undefined,
    });
  };

  render() {
    const { children } = this.props;
    const { dialogOpen, commitCallback, cancelCallback, year } = this.state;

    return (
      <KodplanConsumer>
        {({ activeKodplan }) => (
          <>
            {children({ validateYear: this.validateYear(activeKodplan) })}
            <EkonomiskAnalysInvalidYearDialog
              open={dialogOpen}
              onClose={this.onDialogClose}
              onExited={this.onDialogExited}
              commitCallback={commitCallback}
              cancelCallback={cancelCallback}
              activeKodplan={activeKodplan}
              year={year}
            />
          </>
        )}
      </KodplanConsumer>
    );
  }
}

export default EkonomiskAnalysYearValidator;
